import React, { useEffect, useRef, useState } from 'react';

export default function PDFViewer({ file, pageNumber, onLoadSuccess }) {
  const iframeRef = useRef(null);
  const [currentFile, setCurrentFile] = useState(file);
  const [isLoaded, setIsLoaded] = useState(false);

  // PDF.js viewer URL 생성 (초기 로드용)
  const viewerUrl = `/pdfjs-viewer/viewer.html?file=${encodeURIComponent(file)}`;

  // 파일이 변경되면 iframe 리로드
  useEffect(() => {
    if (currentFile !== file) {
      setCurrentFile(file);
      setIsLoaded(false);
    }
  }, [file, currentFile]);

  // 페이지 번호가 변경되면 iframe에 메시지 전송 (iframe 리로드 없이)
  useEffect(() => {
    if (isLoaded && iframeRef.current && iframeRef.current.contentWindow) {
      try {
        // PDF.js viewer에 페이지 변경 명령 전송
        iframeRef.current.contentWindow.PDFViewerApplication?.pdfViewer?.scrollPageIntoView({
          pageNumber: pageNumber
        });
      } catch (error) {
        console.log('페이지 변경 실패 (보안 제한):', error);
      }
    }
  }, [pageNumber, isLoaded]);

  const handleLoad = () => {
    setIsLoaded(true);
    if (onLoadSuccess) {
      onLoadSuccess();
    }
  };

  return (
    <div className="relative w-full h-full">
      <iframe
        ref={iframeRef}
        key={`${currentFile}-page${pageNumber}`} // 파일 또는 페이지가 변경될 때 리로드
        src={`${viewerUrl}#page=${pageNumber}&zoom=page-width`}
        className="w-full h-full border-0"
        title="PDF Viewer"
        onLoad={handleLoad}
      />
    </div>
  );
}
